"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = theme;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _context = _interopRequireDefault(require("./context"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function theme(ComponentToWrap, componentName) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2["default"])(_class, _React$Component);

    function _class() {
      (0, _classCallCheck2["default"])(this, _class);
      return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_class).apply(this, arguments));
    }

    (0, _createClass2["default"])(_class, [{
      key: "_getComponentTheme",
      value: function _getComponentTheme(theme) {
        var componentTheme = {};
        var style = this.props.style;

        if (componentName) {
          componentTheme = theme && theme[componentName] || {};
        }

        if ((0, _typeof2["default"])(style) === 'object') {
          componentTheme = (0, _deepmerge["default"])(componentTheme, style);
        }

        return componentTheme;
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        return _react["default"].createElement(_context["default"].Consumer, null, function (theme) {
          return _react["default"].createElement(ComponentToWrap, (0, _extends2["default"])({}, _this.props, {
            theme: _objectSpread({
              palette: theme === null || theme === void 0 ? void 0 : theme.palette
            }, _this._getComponentTheme(theme))
          }));
        });
      }
    }]);
    return _class;
  }(_react["default"].Component), (0, _defineProperty2["default"])(_class, "displayName", 'Theme(' + (ComponentToWrap.displayName || 'Component') + ')'), (0, _defineProperty2["default"])(_class, "propTypes", {
    style: _propTypes["default"].object
  }), _temp;
}